import React from 'react';
import Service from '@superdata/basic-data-service';

// 设计思路：根据传入属性，决定显示静态图片还是视频

const Background = (props: any) => {
  const reg = /\.(png|jpe?g|gif|svg)(\?.*)?$/;
  const reg2 = /\.(mp4|avi|rmvb)(\?.*)?$/;
  const { config } = window.Service ?? Service;
  const sys_back_cartoon: string = config.getField('sys_back_cartoon') as string;
  if (reg2.test(sys_back_cartoon)) {
    return (
      <video src={`${sys_back_cartoon}`} autoPlay muted className={props.className} loop />
    );
  }
  if (reg.test(sys_back_cartoon)) {
    return (
      <img src={`${sys_back_cartoon}`} alt="" className={props.className} />
    )
  }
  else return <div />
};

export default Background;
